import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { includes } from 'lodash-es';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { I18nProperties, DefaultChildrenWNodeFactory } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import css from '../css/resource-parser.m.css';

export interface ResourceDivProperties {
	xqa: string;
	css?: string;
	flags?: string[];
}

const factory = create({ theme }).properties<ResourceDivProperties>();

export const ResourceDiv = factory(({ properties, children, middleware: { theme } }) => {
	const { key, xqa, css: classes = '', flags = [] } = properties();
	const themeCss = theme.classes(css);

	const role = includes(flags, 'ariaRoleList')
		? 'list'
		: includes(flags, 'ariaRoleListitem')
		? 'listitem'
		: includes(flags, 'ariaRolePresentation')
		? 'presentation'
		: '';

	return v('div', { key, xqa, role, classes: [themeCss.resourcepara, ...classes.split(' ')] }, children());
});
